import type { Account } from '@/types/serializers'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface ContactInformationProps {
  account: Account
}

export default function ContactInformation({ account }: ContactInformationProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Contact Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <div className="font-medium">
              {account.contactPerson?.name || 'Contact Person'}
            </div>
            <div className="text-sm text-muted-foreground">
              {account.contactPerson?.title || 'Title'}
            </div>
          </div>
          <div className="space-y-2">
            <div className="text-sm text-muted-foreground">
              {account.contactPerson?.email || 'email@example.com'}
            </div>
            <div className="text-sm text-muted-foreground">
              {account.contactPerson?.phone || '+1-555-0000'}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}